import React  from 'react';
import { EditGuesser, InputGuesser } from "@api-platform/admin";
import { ReferenceInput, SelectInput, ReferenceArrayInput, SelectArrayInput, AutocompleteInput } from 'react-admin';
import { RichTextInput } from '@agilie/ra-tinymce-input';

const PortfolioCategoryEdit = (props) => (
  <EditGuesser {...props}>
    <ReferenceInput
      label="File"
      source="file"
      reference="files"
      perPage={1500}
      filter={{ title: "Ressource (Category) -" }}
    >
      <AutocompleteInput optionText="title" />
    </ReferenceInput>
    <ReferenceArrayInput
      label="SubCategories"
      reference="portfolio_sub_categories"
      source="subCategories"
      perPage={10000}
    >
      <SelectArrayInput source="title" />
    </ReferenceArrayInput>
    <InputGuesser source="name" />
    <InputGuesser source="title" />
    <p>Description:</p>
    <RichTextInput label="Description" source="description"
      apiKey='kajmvp4egjobgynq3phsfqif168so5skv2apq56c5zmjum5a'
      init={{
          height: 500,
          menubar: true,
          plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
          ],
          toolbar: 'undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
      }}
    />
    <ReferenceInput label="Language" source="language" reference="languages">
      <SelectInput optionText="name" />
    </ReferenceInput>
  </EditGuesser>
  );

export default PortfolioCategoryEdit;